<template>
  <div class="addnew_dialog">
    <el-dialog
      :title="title"
      :before-close="cancelButton"
      :visible.sync="dialogVisible"
      max-width="70%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div class="search_keyword">
          <div class="item_keyword">
            <el-input v-model="name" placeholder="Please Enter Keywords"></el-input>
          </div>
          <div class="search_btn" @click="searchWord">Search</div>
        </div>
        <el-form-item label="Brand list:" prop>
          <div class="permission">
            <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
            <el-tree
              :data="data"
              show-checkbox
              node-key="id"
              default-expand-all
              :props="defaultProps"
              ref="tree"
              :default-checked-keys="defaultArray"
            ></el-tree>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-form-item>
        <el-form-item class="button">
          <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
          <el-button @click="resetForm('ruleForm')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { companyDetail } from '@/common/js/http/version3Api.js'
export default {
  props: ["passVisible", "title", "defaultArray"],
  name: "AddNewDialog",
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      name: "",
      pageSize: 10,   
      pageNum: 1,
      total: 0,
      data: [],
      currentPage: 1,
      companyIds: [],
      allCompanyIds: [],
      defaultProps: {
        label: "ENName",
        id: "id"
      },
      dialogVisible: false,
      ruleForm: {
        region: "",
        region1: ""
      },
      rules: {
        region: [
          { required: true, message: "please choose", trigger: "change" }
        ],
        region1: [
          { required: true, message: "please choose", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.getCompanyList()
  },
  methods: {
    
    //搜索
    searchWord() {
      if(this.name !== '') {
        this.getCompanyList();
      }else {
        this.getCompanyList();
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCompanyList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCompanyList();
    },
    cancelButton() {
      this.resetForm("ruleForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.companyIds = this.$refs.tree.getCheckedKeys();
          this.allCompanyIds = this.data.map(item => {
            return item.id
          })
          this.$emit('submitForm',this.companyIds, this.allCompanyIds)
          this.resetForm("ruleForm");
        } else {
       
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.$emit("visible", false);
      this.$refs.tree.setCheckedKeys([]);
    },
    //获取品牌列表
    getCompanyList() {
     
      let data = {
        name: this.name,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      companyDetail(data).then(res => {
        this.data = res.result.list;
        this.pageSize = res.result.pageSize;
        this.total = res.result.total;
        this.pageNum = res.result.pageNum;
      })
    }
  },
  watch: {
    passVisible(val) {
      this.dialogVisible = val;
    }
  }
};
</script>

<style scoped>
.addnew_dialog >>> .el-form-item__content .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.addnew_dialog >>> .el-form-item__content {
  margin-left: 0 !important;
}
.addnew_dialog >>> .el-form-item .el-form-item__label {
  line-height: 10px;
}
.option_title {
  text-align: right;
  display: inline-block;
  width: 240px;
  margin-right: 10px;
}
.addnew_dialog >>> .button .el-form-item__content button {
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
}
.addnew_dialog >>> .button {
  text-align: right;
  margin-bottom: 0;
}
.addnew_dialog >>> .el-form-item__content .el-form-item__error {
  left: 250px;
}
.addnew_dialog >>> .el-form-item__content .el-select {
  width: calc(100% - 260px);
}
.permission {
  height: 300px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow-y: scroll;
}
.paging {
  text-align: center;
  padding-top: 20px;
}
.search_keyword {
  padding: 10px 0;
  width: 100%;
  display: flex;
}
.search_keyword .search_btn {
  padding: 8px 10px;
  border: 1px solid #409EFF;
  color: #409EFF;
  border-radius: 2px;
  margin-left: 10px;
}
.search_keyword .item_keyword {
  
  margin-left: 100px;
}
.paging >>> .el-pagination__sizes {
  margin: 0 80px 0 0 !important;
}
</style>